module.exports = __webpack_public_path__ + "static/media/home_tunnel_2.0ffab2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_2.png
// module id = 113
// module chunks = 0